import { useEffect, useState } from 'react';
import {
  fetchTentCartAPI,
  deleteTentCartItemAPI,
  updateTentCartItemAPI,
  getTentHouseProviderServicesAPI,
  refundtentproviderfromcartapi
} from '../Apiservices/Auth/cart/Addtocart_api';
import { useDispatch } from 'react-redux';
import { addServiceToCart, removeTentHouseByProviderId } from '../store/cartbodydataslice';

export const useTentCart = () => {
  const [tentCartData, setTentCartData] = useState([]);
  const [tentCartLoading, setTentCartLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchOrders = async () => {
      setTentCartLoading(true);
      try {
        const response = await fetchTentCartAPI();
        // console.log("tentdata",response.data)
        response.data.forEach((cartitem) => {
          const eveId = cartitem.event_id;
          const eventname = cartitem.event_title;
          const event_start_date = cartitem.event_start_date
          cartitem.tent_providers.forEach((tentitem) => {
            const provider = tentitem;
            const pricingData = provider.pricing || {};
            dispatch(
              addServiceToCart({
                eveId,
                eventname: eventname,
                event_start_date: event_start_date,
                type: 'tentHouseData',
                item: {
                  ...tentitem,
                  provider_id: provider.provider_id,
                  balance_to_be_paid: provider.balance_to_be_paid,
                  is_checked_out: provider.is_checked_out,
                  is_edit_allowed: provider.is_edit_allowed,
                  paid_amount: provider.paid_amount,
                  providername: (provider.first_name ?? "") + ' ' + (provider.lastName ?? ""),
                  services: tentitem.items.map((item) => ({
                    ...item,
                    cart_id: item.cart_id,
                    mapping_id: item.mapping_id,
                    service_id: item.service_id,
                    quantity: item.quantity,
                    price: item.price,
                    discountPrice: item.discount_price,
                    validUpto: item.discount_valid_upto,
                  }))
                },
              })
            );
          });
        });

        setTentCartData(response?.data || []);
      } catch (err) {
        console.error('Error loading tent cart:', err);
        setTentCartData([]);
      }
      setTentCartLoading(false);
    };

    fetchOrders();
  }, [refreshTrigger]);

  const refreshTentCart = () => setRefreshTrigger((prev) => prev + 1);

  const transformUpdatedItems = (updatedItems) => {
    if (updatedItems.length === 0) return null;

    const { event_id, provider_id } = updatedItems[0];

    const items = updatedItems.map(item => ({
      mapping_id: item.mapping_id,
      quantity: item.quantity
    }));

    return {
      event_id,
      provider_id,
      items
    };
  };


  const editbutton = async (eventId, providerId, updatedItems) => {
    try {

      const itemsToUpdate = updatedItems.map(item => ({
        mapping_id: item.mapping_id,
        quantity: item.quantity,
      }));
      const formattedPayload = transformUpdatedItems(updatedItems);
      const { event_id, provider_id, items } = formattedPayload
      const result = await updateTentCartItemAPI(event_id, provider_id, items);


      refreshTentCart();

      return { success: true, message: "Edit saved and cart refreshed" };
    } catch (err) {
      console.error("Edit error:", err);
      return { success: false, message: "Failed to edit cart" };
    }
  };



  const removeTentProvider = async (event_id, provider_id) => {
    try {
      await deleteTentCartItemAPI(event_id, provider_id);

      dispatch(removeTentHouseByProviderId({ eventId: event_id, providerId: provider_id, }));
      refreshTentCart();
    } catch (error) {
      console.error("Error removing tent cart item:", error);
    }
  };
  const refundtentproviderfromcart = async (event_id, provider_id) => {
    try {
      const response = await refundtentproviderfromcartapi(event_id, provider_id);
      return response;
    } catch (error) {
      console.error("Refund Priest from cart error:", error.message);
      throw error;
    }
  };

  return {
    tentCartData,
    tentCartLoading,
    refreshTentCart,
    removeTentProvider,
    editbutton,
    refundtentproviderfromcart,
  };
};
